import {
  ApiChartPayload,
  ApiChartTemplate,
  ApiChartType,
  ApiChartYAxisKey,
  ApiDimension,
} from "@incendium/api";
import { chartService } from "Apis";
import { IChart } from "Interfaces";
import { parseIChartToChartPayload } from "features/chartLibrary/utils";

export const saveChart = async (chart: IChart, projectId: number) => {
  const type =
    chart.type && chart.type !== ApiChartType.UNDEFINED
      ? chart.type
      : ApiChartType.TABLE;

  const dimension =
    chart.dimension && chart.dimension.length > 0
      ? chart.dimension
      : chart.type === ApiChartType.STAT_CARD
        ? []
        : chart.template === ApiChartTemplate.TREND
          ? [ApiDimension.DIMENSION_SESSION_START_BY_DAY]
          : undefined;

  const payload = parseIChartToChartPayload({
    ...chart,
    type,
    dimension,
  });

  return chartService.chartServiceCreateChart({
    projectId,
    payload,
  });
};

export const saveStandardChart = async (
  chart: IChart,
  projectId: number,
  chartKey: string,
) => {
  return chartService.chartServiceUpdateStandardChart({
    projectId,
    chartKey,
    payload: {
      ...chart,
      yAxisKeys: (chart.yAxisKeys || []).filter(
        (v) => typeof v !== "string",
      ) as ApiChartYAxisKey[], // filter should not be needed but here yo guarantee type
    },
  });
};

export const getStandardChart = async (projectId: number, chartKey: string) => {
  return chartService.chartServiceReadStandardChart({
    projectId,
    chartKey,
  });
};

export const deleteStandardChart = async (
  projectId: number,
  chartKey: string,
) => {
  return chartService.chartServiceDeleteStandardChart({
    projectId,
    chartKey,
  });
};

export const exportStandardChart = async (
  projectId: number,
  chart: ApiChartPayload,
  opt: {
    from?: Date;
    to?: Date;
    lastNDays?: number;
    timezone?: string;
  },
) => {
  return chartService.chartServiceReadChartCSV({
    projectId,
    payload: {
      chart,
      from: opt.from,
      to: opt.to,
      lastNDays: opt.lastNDays,
      timezone: opt.timezone,
    },
  });
};
